import Common from '../common/Common'

const Feedback = {
    ...Common,
}

export default Feedback;
